import React, { useState } from "react";
import { BessAlerts } from "./BessAlerts";
import { BessSummaryCards } from "./BessSummaryCards";
import BessMonthChart from "./BessMonthChart";
import { BessDayChart, getDefaultDay } from "./BessDayChart";
import { BessDailyTable } from "./BessDailyTable";
import { BessEnergyBalance } from "./BessEnergyBalance";
import { BessCsvButton, BessXlsxButton } from "./BessExportButton";
import { BessSimulationResult, FormValues } from "../../types";

interface BessSectionProps {
  bess: BessSimulationResult;
  values: FormValues;
}

const formatPeakWindow = (horasPonta: number[]): string => {
  if (horasPonta.length === 0) return "";
  const sorted = [...horasPonta].sort((a, b) => a - b);
  // hora 19 = 18:00–18:59 → janela exibida como 18h–21h
  return `${sorted[0] - 1}h–${sorted[sorted.length - 1]}h`;
};

export const BessSection = ({ bess, values }: BessSectionProps) => {
  const [selectedDay, setSelectedDay] = useState(() =>
    getDefaultDay(bess.horaria)
  );
  const { parametros, resumo, horaria, diaria, avisos, origemSerie } = bess;
  const medida = origemSerie.tipo === "MEDICAO";

  return (
    <div style={{ marginTop: 24 }}>
      <div className="simulacao-header-title">
        <h1>Operação da bateria</h1>
        <h2>
          Simulação hora a hora sobre{" "}
          {medida
            ? `a medição de ${origemSerie.mesReferencia} · ponto ${parametros.pontoMedicao}`
            : `o perfil ${origemSerie.perfil?.codigo} em ${origemSerie.mesReferencia}`}{" "}
          · janela de ponta {formatPeakWindow(parametros.horasPonta)} ·
          capacidade útil{" "}
          {Math.round(parametros.capacidadeUtilKwh).toLocaleString("pt-BR")} kWh
        </h2>
      </div>

      <BessAlerts resumo={resumo} parametros={parametros} avisos={avisos} />

      <BessSummaryCards resumo={resumo} />

      <BessEnergyBalance balanco={bess.balancoEnergetico} />

      <BessMonthChart diaria={diaria} onSelectDay={setSelectedDay} />

      <BessDayChart
        horaria={horaria}
        parametros={parametros}
        selectedDay={selectedDay}
        onSelectDay={setSelectedDay}
      />

      <h4 className="bess-section-title" style={{ marginBottom: 8 }}>
        Detalhamento diário
      </h4>
      <BessDailyTable diaria={diaria} horaria={horaria} resumo={resumo} />

      <div
        style={{
          margin: "20px 0",
          display: "flex",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <BessXlsxButton values={values} />
        {/* Sem medição não existe arquivo ajustado para exportar. */}
        {medida && <BessCsvButton values={values} />}
      </div>
    </div>
  );
};
